<template>
  <card v-if="(items && items.length >0) || $root.courseScouterType === 'Participant'">
    <h5
      slot="header"
      class="card-title text-danger font-weight-bold"
    >
      Today's Calendar
    </h5>
    <div v-if="items !== null">
      <el-table
        :data="items"
        header-row-class-name="text-danger"
        size="small"
        :header-cell-style="headerCellStyle"
        :cell-style="cellStyle"
        v-if="items.length > 0"
      >
        <el-table-column
          label="Activity"
          property="Topic"
          min-width="130"
        />
        <el-table-column
          label="Location"
          property="LocationInfo"
        />
      </el-table>
    </div>
    <div v-else>
      <h5>There are no scheduled activities for today.</h5>
    </div>
  </card>
</template>

<script>
import agendaItemsApi from '@/services/api/agenda-item.js'
import dayjs from 'dayjs'

export default {
  name: 'HomeSharedCalendar',
  data: function () {
    return {
      items: [],
      cellStyle: { padding: '0', height: '20px', 'font-size': '10px', 'word-wrap': 'normal', 'word-break': 'normal' },
      headerCellStyle: {
        padding: '0',
        height: '20px',
        'font-size': '10px',
        'text-align': 'left',
        'word-wrap': 'break-word'
      }
    }
  },
  mounted: function () {
    const dateOf = new Date()
    const dt = dayjs(dateOf).format('YYYY-MM-DD')
    agendaItemsApi.getParticipantAgenda(this.$root.courseKey, this.$root.courseScouterType, dt)
      .then(x => {
        this.items = x
      })
      .catch(error => {
        console.log(error)
        this.$notify({
          message: 'There was an error retrieving your data.',
          icon: 'bi bi-exclamation-circle-fill',
          type: 'error',
          horizontalAlign: 'center',
          timeout: 2000
        })
        this.errormessage = error
      })
      .finally(() => {
        this.loading = false
      })
  }
}
</script>
